import {
  FETCH_WORK_CARDS,
  FETCH_WORK_CARDS_SUCCESS,
  FETCH_WORK_CARDS_ERROR,
  SET_ACTIVE_CARD,
  WorkCardsActionTypes,
  WorkCardState,
} from './types';

const initialState: WorkCardState = {
  loading: true,
  activeCard: '',
  data: [
    { id: 'photos', label: 'Photos', available: 0 },
    { id: 'videos', label: 'Videos', available: 0 },
    { id: 'text', label: 'Text', available: 0 },
    { id: 'multiple', label: 'Multiple', available: 0 },
    { id: 'new_listings', label: 'New Listings', available: 0 },
  ],
};

export default function workCardsReducer(
  state = initialState,
  action: WorkCardsActionTypes
): WorkCardState {
  switch (action.type) {
    case FETCH_WORK_CARDS: {
      return {
        ...state,
        loading: true,
      };
    }
    case FETCH_WORK_CARDS_SUCCESS: {
      const { data } = action;
      return {
        ...state,
        loading: false,
        data,
      };
    }
    case FETCH_WORK_CARDS_ERROR: {
      return {
        ...state,
        loading: false,
      };
    }
    case SET_ACTIVE_CARD: {
      const { cardId } = action;
      return {
        ...state,
        activeCard: cardId,
      };
    }
    default:
      return state;
  }
}
